import { Table } from 'antd';
import type { TableProps } from 'antd';

/**
 * Shared data grid. Thin wrapper over antd Table with project defaults: row key defaults to `id`,
 * horizontal scroll for wide tables (architecture §4.4), and no built-in pagination
 * (server-side pagination is handled by the <Pagination /> component). Any prop can be overridden.
 */
export default function DataTable<T extends object>(props: TableProps<T>) {
  return (
    <Table<T>
      size="middle"
      bordered
      rowKey="id"
      pagination={false}
      scroll={{ x: 'max-content' }}
      {...props}
    />
  );
}
